import { compose } from '@reduxjs/toolkit';
import { activateUserReducer } from './activateUser';
import { editUserReducer } from './editUser';
import { fetchUserListReducer } from './fetchUserList';

export const extraReducers = compose(fetchUserListReducer, editUserReducer, activateUserReducer);
export { activateUser } from './activateUser';
export { editUser } from './editUser';
export { fetchUserList } from './fetchUserList';
